import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = 'https://martianbluecyberdefense.in';

const Portal = () => {
  const [view, setView] = useState('login');
  const [student, setStudent] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('portalToken') || '');
  const [content, setContent] = useState(null);
  const [selectedModule, setSelectedModule] = useState(null);
  const [contentType, setContentType] = useState('video');
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [activeCourseIdx, setActiveCourseIdx] = useState(0);

  const loadPdf = async (filename, tokenOverride) => {
    try {
      const token = tokenOverride || localStorage.getItem('portalToken');
      const res = await fetch(`/api/portal/pdf/${filename}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
    } catch (err) {
      console.error('PDF load error:', err);
    }
  };
  const switchCourse = (idx) => {
    if (!content?.courses) return;
    const course = content.courses[idx];
    setActiveCourseIdx(idx);
    const updatedContent = { ...content, modules: course.modules, courseName: course.name };
    setContent(updatedContent);
    if (course.modules && course.modules.length > 0) {
      setSelectedModule(course.modules[0]);
      loadPdf(course.modules[0].pdf.id);
    }
  };
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loginData, setLoginData] = useState({ email: '', password: '' });

  useEffect(() => {
    const block = (e) => {
      if (e.key === 'F12') e.preventDefault();
      if (e.ctrlKey && e.shiftKey && ['I','J','C'].includes(e.key)) e.preventDefault();
      if (e.ctrlKey && e.key === 'u') e.preventDefault();
    };
    document.addEventListener('keydown', block);
    return () => document.removeEventListener('keydown', block);
  }, []);
  const [pwData, setPwData] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });

  useEffect(() => {
    if (token) fetchContent();
  }, [token]);

  const fetchContent = async () => {
    try {
      const currentToken = localStorage.getItem('portalToken') || token;
      const res = await axios.get(`${API_BASE}/api/portal/content`, { headers: { Authorization: `Bearer ${currentToken}` } });
      if (res.data.success) {
        const c = res.data.content;
        // Support new multi-course format
        if (c.courses && c.courses.length > 0) {
          // flatten for backward compat but store courses too
          c.modules = c.courses[0].modules;
          c.courseName = c.courses[0].name;
        }
        setContent(c);
        setStudent({ fullName: c.studentName, email: c.studentEmail, studentId: c.studentId });
        setView('dashboard');
        if (c.modules && c.modules.length > 0) {
          setSelectedModule(c.modules[0]);
          loadPdf(c.modules[0].pdf.id, currentToken);
        }
      }
    } catch { localStorage.removeItem('portalToken'); setToken(''); }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); setStatus({ type: '', message: '' });
    try {
      const res = await axios.post(`${API_BASE}/api/portal/login`, loginData);
      if (res.data.success) {
        localStorage.setItem('portalToken', res.data.token);
        setToken(res.data.token);
        setStudent(res.data.student);
        if (res.data.student.mustChangePassword) setView('changePassword');
        else fetchContent();
      }
    } catch (err) {
      setStatus({ type: 'error', message: err.response?.data?.message || 'Login failed' });
    } finally { setLoading(false); }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (pwData.newPassword !== pwData.confirmPassword) { setStatus({ type: 'error', message: 'Passwords do not match' }); return; }
    if (pwData.newPassword.length < 8) { setStatus({ type: 'error', message: 'Password must be at least 8 characters' }); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE}/api/portal/change-password`, { currentPassword: pwData.currentPassword, newPassword: pwData.newPassword }, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.success) {
        setStatus({ type: 'success', message: '✅ Password changed!' });
        setTimeout(() => { setStatus({ type: '', message: '' }); fetchContent(); }, 2000);
      }
    } catch (err) {
      setStatus({ type: 'error', message: err.response?.data?.message || 'Failed' });
    } finally { setLoading(false); }
  };

  const logout = () => { localStorage.removeItem('portalToken'); setToken(''); setStudent(null); setContent(null); setView('login'); };

  const inputStyle = { width: '100%', padding: '12px 14px', borderRadius: 10, background: '#061c36', border: '1.5px solid rgba(0,212,255,0.3)', color: '#fff', fontFamily: 'Poppins,sans-serif', fontSize: 14, outline: 'none', boxSizing: 'border-box' };
  const labelStyle = { color: '#94a3b8', fontFamily: 'Poppins,sans-serif', fontSize: 13, marginBottom: 6, display: 'block' };

  // Login Page
  if (view === 'login') return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#061c36 0%,#0a2540 50%,#061c36 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🎓</div>
          <h1 style={{ color: '#fff', fontFamily: 'Rajdhani,sans-serif', fontSize: 32, fontWeight: 700, margin: '0 0 8px' }}>Student Portal</h1>
          <p style={{ color: '#94a3b8', fontFamily: 'Poppins,sans-serif', fontSize: 14 }}>Martian Blue Cyber Defense</p>
        </div>
        <form onSubmit={handleLogin} style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(0,212,255,0.2)', borderRadius: 20, padding: 32 }}>
          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Email</label>
            <input type="email" value={loginData.email} onChange={e => setLoginData(p => ({ ...p, email: e.target.value }))} placeholder="your@email.com" style={inputStyle} required />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={labelStyle}>Password</label>
            <input type="password" value={loginData.password} onChange={e => setLoginData(p => ({ ...p, password: e.target.value }))} placeholder="Your password" style={inputStyle} required />
          </div>
          {status.message && (
            <div style={{ padding: '10px 14px', borderRadius: 8, marginBottom: 16, background: 'rgba(255,107,107,0.1)', border: '1px solid rgba(255,107,107,0.4)' }}>
              <p style={{ color: '#ff6b6b', fontFamily: 'Poppins,sans-serif', fontSize: 13, margin: 0 }}>{status.message}</p>
            </div>
          )}
          <button type="submit" disabled={loading} style={{ width: '100%', padding: 14, borderRadius: 12, background: 'linear-gradient(135deg,#00d4ff,#00b4d8)', color: '#000', fontFamily: 'Rajdhani,sans-serif', fontWeight: 700, fontSize: 18, border: 'none', cursor: 'pointer' }}>
            {loading ? '⏳ Logging in...' : '🔐 Login'}
          </button>
        </form>
      </div>
    </div>
  );

  // Change Password Page
  if (view === 'changePassword') return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#061c36 0%,#0a2540 50%,#061c36 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🔑</div>
          <h1 style={{ color: '#fff', fontFamily: 'Rajdhani,sans-serif', fontSize: 28, fontWeight: 700, margin: '0 0 8px' }}>Change Password</h1>
          <p style={{ color: '#94a3b8', fontFamily: 'Poppins,sans-serif', fontSize: 14 }}>Please change your password to continue</p>
          <button onClick={() => setView('dashboard')} style={{ marginTop: 12, padding: '8px 20px', borderRadius: 8, background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)', color: '#00d4ff', fontSize: 13, cursor: 'pointer' }}>← Back to Dashboard</button>
        </div>
        <form onSubmit={handleChangePassword} style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(0,212,255,0.2)', borderRadius: 20, padding: 32 }}>
          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Current Password</label>
            <input type="password" value={pwData.currentPassword} onChange={e => setPwData(p => ({ ...p, currentPassword: e.target.value }))} style={inputStyle} required />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>New Password</label>
            <input type="password" value={pwData.newPassword} onChange={e => setPwData(p => ({ ...p, newPassword: e.target.value }))} placeholder="Min 8 characters" style={inputStyle} required />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={labelStyle}>Confirm New Password</label>
            <input type="password" value={pwData.confirmPassword} onChange={e => setPwData(p => ({ ...p, confirmPassword: e.target.value }))} style={inputStyle} required />
          </div>
          {status.message && (
            <div style={{ padding: '10px 14px', borderRadius: 8, marginBottom: 16, background: status.type === 'error' ? 'rgba(255,107,107,0.1)' : 'rgba(0,255,100,0.1)', border: `1px solid ${status.type === 'error' ? 'rgba(255,107,107,0.4)' : 'rgba(0,255,100,0.4)'}` }}>
              <p style={{ color: status.type === 'error' ? '#ff6b6b' : '#00ff64', fontFamily: 'Poppins,sans-serif', fontSize: 13, margin: 0 }}>{status.message}</p>
            </div>
          )}
          <button type="submit" disabled={loading} style={{ width: '100%', padding: 14, borderRadius: 12, background: 'linear-gradient(135deg,#00d4ff,#00b4d8)', color: '#000', fontFamily: 'Rajdhani,sans-serif', fontWeight: 700, fontSize: 18, border: 'none', cursor: 'pointer' }}>
            {loading ? '⏳ Changing...' : '🔑 Change Password'}
          </button>
        </form>
      </div>
    </div>
  );

  // Dashboard
  if (view === 'dashboard' && content) return (
    <div style={{ minHeight: '100vh', background: '#061c36', fontFamily: 'Poppins,sans-serif' }} onContextMenu={e => e.preventDefault()} onKeyDown={e => {
    if (e.key === 'F12') e.preventDefault();
    if (e.ctrlKey && e.shiftKey && ['I','J','C'].includes(e.key)) e.preventDefault();
    if (e.ctrlKey && e.key === 'u') e.preventDefault();
  }}>
      {/* Header */}
      <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, height: 64, background: 'rgba(6,28,54,0.98)', borderBottom: '1px solid rgba(0,212,255,0.2)', display: 'flex', alignItems: 'center', padding: '0 24px', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ fontSize: 24 }}>🎓</span>
          <span style={{ color: '#00d4ff', fontFamily: 'Rajdhani,sans-serif', fontWeight: 700, fontSize: 20 }}>Student Portal</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ color: '#94a3b8', fontSize: 13 }}>👤 {student?.fullName}</span>
          <button onClick={() => setView('changePassword')} style={{ padding: '6px 14px', borderRadius: 8, background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)', color: '#00d4ff', fontSize: 12, cursor: 'pointer' }}>🔑 Change Password</button>
          <button onClick={logout} style={{ padding: '6px 14px', borderRadius: 8, background: 'rgba(255,107,107,0.1)', border: '1px solid rgba(255,107,107,0.3)', color: '#ff6b6b', fontSize: 12, cursor: 'pointer' }}>Logout</button>
        </div>
      </nav>

      <div style={{ paddingTop: 64, display: 'flex', minHeight: '100vh' }}>
        {/* Sidebar */}
        <div style={{ width: '20%', minWidth: 160, background: 'rgba(255,255,255,0.02)', borderRight: '1px solid rgba(0,212,255,0.1)', padding: 20, overflowY: 'auto' }}>
          {content?.courses && content.courses.length >= 1 && (
            <div style={{ marginBottom: 16 }}>
              <p style={{ color: '#94a3b8', fontSize: 11, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 10 }}>📖 My Courses</p>
              {content.courses.map((course, idx) => (
                <button key={course.id} onClick={() => switchCourse(idx)}
                  style={{ width: '100%', textAlign: 'left', padding: '10px 14px', borderRadius: 10, marginBottom: 6, background: activeCourseIdx === idx ? 'rgba(0,255,128,0.1)' : 'transparent', border: `1px solid ${activeCourseIdx === idx ? 'rgba(0,255,128,0.4)' : 'rgba(255,255,255,0.05)'}`, color: activeCourseIdx === idx ? '#00ff80' : '#94a3b8', fontSize: 12, cursor: 'pointer', fontWeight: activeCourseIdx === idx ? 700 : 400 }}>
                  {course.name}
                </button>
              ))}
              <div style={{ height: 1, background: 'rgba(0,212,255,0.1)', margin: '12px 0' }} />
            </div>
          )}
          <p style={{ color: '#94a3b8', fontSize: 11, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>📚 Course Modules</p>
          {content.modules.map(mod => (
            <button key={mod.id} onClick={() => { setSelectedModule(mod); loadPdf(mod.pdf.id); }}
              style={{ width: '100%', textAlign: 'left', padding: '12px 14px', borderRadius: 10, marginBottom: 8, background: selectedModule?.id === mod.id ? 'rgba(0,212,255,0.1)' : 'transparent', border: `1px solid ${selectedModule?.id === mod.id ? 'rgba(0,212,255,0.4)' : 'rgba(255,255,255,0.05)'}`, color: selectedModule?.id === mod.id ? '#00d4ff' : '#cbd5e1', fontSize: 13, cursor: 'pointer' }}>
              {mod.title}
            </button>
          ))}
        </div>

        {/* Main Content */}
        <div style={{ flex: 1, padding: 24, overflowY: 'auto' }}>
          {selectedModule && (
            <>
              <h2 style={{ color: '#fff', fontFamily: 'Rajdhani,sans-serif', fontSize: 24, marginBottom: 20 }}>{selectedModule.title}</h2>

              {/* Tabs */}
              <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
                <button onClick={() => setContentType('video')}
                  style={{ padding: '8px 20px', borderRadius: 8, background: contentType === 'video' ? 'rgba(0,212,255,0.2)' : 'transparent', border: `1px solid ${contentType === 'video' ? '#00d4ff' : 'rgba(255,255,255,0.1)'}`, color: contentType === 'video' ? '#00d4ff' : '#94a3b8', cursor: 'pointer', fontSize: 14 }}>
                  🎥 Video
                </button>
                <button onClick={() => setContentType('pdf')}
                  style={{ padding: '8px 20px', borderRadius: 8, background: contentType === 'pdf' ? 'rgba(0,212,255,0.2)' : 'transparent', border: `1px solid ${contentType === 'pdf' ? '#00d4ff' : 'rgba(255,255,255,0.1)'}`, color: contentType === 'pdf' ? '#00d4ff' : '#94a3b8', cursor: 'pointer', fontSize: 14 }}>
                  📄 PDF
                </button>
              </div>

              {/* Video Player */}
              {contentType === 'video' && (
                <div style={{ position: 'relative' }}>
                  <div style={{ position: 'relative', paddingBottom: '32%', height: 0, borderRadius: 12, overflow: 'hidden', border: '1px solid rgba(0,212,255,0.2)' }}>
                    <iframe
                      src={`https://www.youtube.com/embed/${selectedModule.video.id}?rel=0&modestbranding=1`}
                      style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}
                      frameBorder="0" allowFullScreen
                      title={selectedModule.video.title}
                    />
                  </div>
                {/* Watermark */}
                  <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 10, overflow: 'hidden' }}>
                    {Array.from({length: 6}).map((_, i) => (
                      <div key={i} style={{ position: 'absolute', top: `${i * 18}%`, left: '-10%', width: '120%', textAlign: 'center', transform: 'rotate(-30deg)', opacity: 0.08, fontSize: 13, color: '#fff', fontFamily: 'monospace', whiteSpace: 'nowrap', userSelect: 'none' }}>
                        {content.studentEmail} • {content.studentId} &nbsp;&nbsp;&nbsp; {content.studentEmail} • {content.studentId}
                      </div>
                    ))}
                  </div>
                  <div style={{ position: 'absolute', top: 12, right: 12, background: 'rgba(0,0,0,0.6)', padding: '4px 10px', borderRadius: 6, pointerEvents: 'none', zIndex: 11 }}>
                    <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11 }}>{content.studentEmail}</span>
                  </div>
                </div>
              )}

              {/* PDF Viewer */}
              {contentType === 'pdf' && (
                <div style={{ position: 'relative', borderRadius: 12, overflow: 'hidden', border: '1px solid rgba(0,212,255,0.2)' }}>
                  <iframe
                    src={pdfUrl ? pdfUrl + '#toolbar=0&navpanes=0&scrollbar=0' : ''}
                    style={{ width: '100%', height: '70vh', border: 'none', pointerEvents: 'auto' }}
                    title={selectedModule.pdf.title}
                  />
                  <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px 12px', background: 'rgba(6,28,54,0.95)', borderBottom: '1px solid rgba(0,212,255,0.1)' }}>
                  <button onClick={() => setIsFullscreen(true)} style={{ padding: '6px 16px', borderRadius: 8, background: 'rgba(0,212,255,0.15)', border: '1px solid rgba(0,212,255,0.3)', color: '#00d4ff', fontSize: 12, cursor: 'pointer' }}>⛶ View Full Size</button>
                </div>
                {isFullscreen && (
                  <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#061c36', zIndex: 9999, display: 'flex', flexDirection: 'column' }} onContextMenu={e => e.preventDefault()} onKeyDown={e => { if (e.key === 'F12') e.preventDefault(); if (e.ctrlKey && e.shiftKey && ['I','J','C'].includes(e.key)) e.preventDefault(); if (e.ctrlKey && e.key === 'u') e.preventDefault(); }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 20px', background: 'rgba(6,28,54,0.98)', borderBottom: '1px solid rgba(0,212,255,0.2)' }}>
                      <span style={{ color: '#00d4ff', fontSize: 14, fontFamily: 'Rajdhani,sans-serif', fontWeight: 700 }}>📄 {selectedModule.pdf.title}</span>
                      <button onClick={() => setIsFullscreen(false)} style={{ padding: '6px 16px', borderRadius: 8, background: 'rgba(255,107,107,0.15)', border: '1px solid rgba(255,107,107,0.3)', color: '#ff6b6b', fontSize: 13, cursor: 'pointer' }}>✕ Close</button>
                    </div>
                    <div style={{ flex: 1, position: 'relative', overflow: 'hidden' }}>
                      <iframe src={pdfUrl ? pdfUrl + '#toolbar=0&navpanes=0&scrollbar=0' : ''} style={{ width: '100%', height: '100%', border: 'none' }} title="fullscreen-pdf" />
                      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 10, overflow: 'hidden' }}>
                        {Array.from({length: 8}).map((_, i) => (
                          <div key={i} style={{ position: 'absolute', top: i * 14 + '%', left: '-10%', width: '120%', textAlign: 'center', transform: 'rotate(-30deg)', opacity: 0.07, fontSize: 13, color: '#000', fontFamily: 'monospace', whiteSpace: 'nowrap', userSelect: 'none' }}>
                            {content.studentEmail} • {content.studentId} &nbsp;&nbsp;&nbsp; {content.studentEmail} • {content.studentId}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                {/* Watermark */}
                  <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 10, overflow: 'hidden' }}>
                    {Array.from({length: 8}).map((_, i) => (
                      <div key={i} style={{ position: 'absolute', top: `${i * 14}%`, left: '-10%', width: '120%', textAlign: 'center', transform: 'rotate(-30deg)', opacity: 0.07, fontSize: 13, color: '#000', fontFamily: 'monospace', whiteSpace: 'nowrap', userSelect: 'none' }}>
                        {content.studentEmail} • {content.studentId} &nbsp;&nbsp;&nbsp; {content.studentEmail} • {content.studentId}
                      </div>
                    ))}
                  </div>
                  <div style={{ position: 'absolute', top: 12, right: 12, background: 'rgba(0,0,0,0.7)', padding: '4px 10px', borderRadius: 6, pointerEvents: 'none', zIndex: 11 }}>
                    <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11 }}>{content.studentEmail} • {content.studentId}</span>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );

  return null;
};

export default Portal;
